
"use client";

import { ListContextProvider, useListController } from "react-admin";
import OrderList from "./OrderList";

const OrdersList = () => {
  const listController = useListController<any>({
    sort: { field: "pickup_time", order: "DESC" },
  });

  return (
    <ListContextProvider value={listController}>
      <div className="w-full p-5">
        <OrderList />
      </div>
    </ListContextProvider>
  );
};

export default OrdersList;
